import { UserModels } from '@project44-models/iam-gateway';

import { Exception } from '../../../../shared/abstract/domain/Exception';

export class UnauthorizedTenantAgnosticRolesUserException extends Exception {
  constructor(public readonly user?: UserModels.UserViewModel) {
    super(`User cannot have tenant agnostic roles: ${user?.userType}'`);
  }

  public static throw(user?: UserModels.UserViewModel): never {
    throw new UnauthorizedTenantAgnosticRolesUserException(user);
  }
}
